const mi = -Infinity;
const mx = Infinity;
const MIN2 = Object.freeze([mi, mi]);
const MAX2 = Object.freeze([mx, mx]);
const ONE2 = Object.freeze([1, 1]);
const ZERO2 = Object.freeze([0, 0]);
const X2 = Object.freeze([1, 0]);
const Y2 = Object.freeze([0, 1]);
const MIN3 = Object.freeze([mi, mi, mi]);
const MAX3 = Object.freeze([mx, mx, mx]);
const ONE3 = Object.freeze([1, 1, 1]);
const ZERO3 = Object.freeze([0, 0, 0]);
const X3 = Object.freeze([1, 0, 0]);
const Y3 = Object.freeze([0, 1, 0]);
const Z3 = Object.freeze([0, 0, 1]);
const MIN4 = Object.freeze([mi, mi, mi, mi]);
const MAX4 = Object.freeze([mx, mx, mx, mx]);
const ONE4 = Object.freeze([1, 1, 1, 1]);
const ZERO4 = Object.freeze([0, 0, 0, 0]);
const X4 = Object.freeze([1, 0, 0, 0]);
const Y4 = Object.freeze([0, 1, 0, 0]);
const Z4 = Object.freeze([0, 0, 1, 0]);
const W4 = Object.freeze([0, 0, 0, 1]);
export {
  MAX2,
  MAX3,
  MAX4,
  MIN2,
  MIN3,
  MIN4,
  ONE2,
  ONE3,
  ONE4,
  W4,
  X2,
  X3,
  X4,
  Y2,
  Y3,
  Y4,
  Z3,
  Z4,
  ZERO2,
  ZERO3,
  ZERO4
};
